export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/login/LoginView.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/auth/register/RegisterView.vue"),
  },
  {
    path: "/verify-email/:token",
    name: "verify-email",
    component: () => import("../views/auth/verify-email/VerifyEmailView.vue"),
  },
  {
    path: "/reset-password/:token",
    name: "reset-password",
    component: () =>
      import("../views/auth/reset-password/ResetPasswordView.vue"),
  },
];
